import { useState } from 'react'
import { LuLoaderCircle } from 'react-icons/lu'

export default function SafeImage({
  src,
  alt,
  fallback = `${import.meta.env.BASE_URL}assets/wsc-logo.svg`,
  className = '',
  fill = false,
  width,
  height,
  ...props
}) {
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(true)

  const handleError = () => {
    setError(true)
    setLoading(false)
  }

  const handleLoad = () => {
    setLoading(false)
  }

  const fillStyle = fill ? { position: 'absolute', width: '100%', height: '100%', objectFit: 'cover' } : {}

  return (
    <>
      {(loading && src) &&
        <div className={`w-full h-full flex items-center justify-center text-secondary-foreground/50 ${className}`}>
          <LuLoaderCircle className='w-6 h-6 animate-spin' />
        </div>
      }
      <div className={`flex items-center justify-center ${className}`}>
          {error || !src ?
            <img src={fallback} alt={alt} width={100} height={100} draggable={false} className='w-1/4 h-1/4 object-contain opacity-30' />
          :
            <img
              src={src}
              alt={alt}
              width={fill ? undefined : width}
              height={fill ? undefined : height}
              style={fillStyle}
              loading="lazy"
              draggable={false}
              className={`${className}`}
              onError={handleError}
              onLoad={handleLoad}
              {...props}
            />
          }
      </div>
    </>
  )
}
